module.exports = __webpack_public_path__ + "dist/assets/_/node_modules/payment-icons/svg/single/mastercard-old__8372b94426e9f73d98213a5379750040.svg";